export const UPDATE_NETWORK = 'NETWORK/UPDATE';

export const updateNetwork = status => ({
  type: UPDATE_NETWORK,
  payload: status,
});
